module.exports = __webpack_public_path__ + "img/curve_line_2_icon.b30006a2.svg";